// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3pFZ1","head":"Table_head__XWP-S","col":"Table_col__la3xq"};